import styled, {
  DefaultTheme,
  StyledComponent
} from "styled-components";

import {
  stripBoolean,
  generateStyles,
  HTMLElementOrReactComponent,
  AnyProps
} from "../helpers";

export interface BaseProps {
  // Positioning
  padding: string;
  margin: string;
  width: string;
  height: string;
  // Display
  visibility: string;
  display: string;
  opacity: number,
  // Coloring
  color: string;
  background: string;
  border: string;
  // Text
  fontSize: string;
  fontWeight: string | number;
  fontStyle: string;
  fontFamily: string;
  lineHeight: number,
  textTransform: string;
  // Convenience Properties
  hidden: boolean;
}

const Base = (element: HTMLElementOrReactComponent): StyledComponent<React.ReactFCWithChildren<AnyProps>, DefaultTheme> => styled(stripBoolean(element))(generateStyles);

export default Base;
